import h from 'virtual-dom/h';
import TimestampRenderer from "./timestamp-renderer";
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {VChild, VTree} from "virtual-dom";
import {HistoryMessage, HistoryMessageAlme} from "../../../../types/history";
import {HistoryMessageLiveChatResponse} from "../models/HistoryMessages";
import LiveChatState from "../livechat-state";
import InlineLinksRenderer from "../../../message-renderer-display-links/src/message-renderer-inline-links";


export default class ResponseRenderer
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _stateManager: LiveChatState;
    _timeStamp: TimestampRenderer;
    _renderTimestamp: (message: HistoryMessage) => VChild;
    _inlineLinkRenderer: InlineLinksRenderer;


    //region Public Interface
    
    constructor(settings: DefaultSettings, stateManager: LiveChatState)
    {
        this._settings = settings;
        this._stateManager = stateManager;
        this._timeStamp = new TimestampRenderer(this._settings.classNames.livechat.timestampResponseClassName, this._settings.livechat.shouldDisplayTimestamp);
        this._renderTimestamp = this._timeStamp.getRender();
        this._inlineLinkRenderer = new InlineLinksRenderer(settings);
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;

        this._inlineLinkRenderer.initialize(store);
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    doesRender(message: HistoryMessageAlme): boolean
    {
        return message.type === this._settings.messageConstants.livechatResponseType && message?.text != null;
    }

    getRenderer()
    {
        return (message: HistoryMessage): VChild =>
        {
            if (!this.doesRender(message as HistoryMessageAlme)) { return []; }

            const typedMessage = message as HistoryMessageLiveChatResponse;
            const { 
                responseContainer, 
                responseDisplayName,
                responseMessage,
                responsePersonaIcon,
                responseText, 
            } = this._settings.classNames.livechat;

            const operatorName = typedMessage.operatorData?.Name ?? this._settings.livechat.defaultOperatorName;
            const title = this._settings.livechat.textConstants.responseTitleText.replace(/{0\}/g, operatorName);

            const paragraph = h('p', this.renderInlineLinks(typedMessage));
            const span = h('span', [paragraph]);
            const text = h('div', { className: responseText }, [span]);
            const displayName = h('div', { className: responseDisplayName }, operatorName);
            const responseNode = h('div', { className: responseMessage, tabIndex:0, title }, [displayName, text]);
            const persona = h('div', { className: responsePersonaIcon }, []);
            const timestamp = this._renderTimestamp(typedMessage);

            return h('div', { className: responseContainer}, [persona, responseNode, timestamp]);
        };
    }
    
    //#endregion



    //#region

    renderInlineLinks(message: HistoryMessageLiveChatResponse): VTree[]
    {
        message.extensionData.postMarkdownHtml = this.urlify(message.text);

        this._inlineLinkRenderer.getRenderer()(message);

        return message.extensionData.postMarkdownVdomElements as VTree[];
    }

    //#endregion

    //#region

    urlify(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function(url) {
          return '<a href="' + url + '" target="_blank">' + url + '</a>';
        });
      }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/response-renderer.ts